<template>
  <div class="table">
    <div class="table-header">
      <p>Người dùng</p>

      <select class="w3-select w3-border" v-model="filterStatus">
        <option value="" disabled selected>Trạng thái</option>
        <option value="">Tất cả</option>
        <option value="1">Hoạt động</option>
        <option value="0">Dừng</option>
      </select>

      <div>
        <input v-model="filterTerm" placeholder="Tên người dùng" @keyup.enter="sendFilterTerm"/>
        <button style="background-color: #0298cf; border-radius: 0px; border-top-right-radius: 6px; border-bottom-right-radius: 6px; height: 40px; margin-right: 15px"
          @click.prevent="sendFilterTerm"><i class="fa-solid fa-magnifying-glass"></i></button>

        <button @click="exportExcel" class="excel-btn" :class="{ loading: requestLoading }" :disabled="requestLoading" v-if="$checkPermission('view_user')">
          <p class="btn-text"><i style="margin-right: 5px;" class="fa-solid fa-file-excel"></i>Xuất Excel</p>
        </button>
        <button @click="addClick" class="add-new" v-if="$checkPermission('create_user')">+ Thêm mới</button>
      </div>
    </div>

    <div class="table-section">
      <table>
        <thead>
          <tr>
            <th>STT</th>
            <th>Tên người dùng</th>
            <th>Email</th>
            <th>Ngày tạo</th>
            <th>Tạo bởi</th>
            <th>Ngày cập nhật</th>
            <th>Cập nhật bởi</th>
            <th>Trạng thái</th>
            <th>Hành động</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(ctt, i) in getUsers" :key="i">
            <td>{{ (currentPage - 1) * pageSize + i + 1 }}</td>
            <td>{{ ctt.username }}</td>
            <td>{{ ctt.email }}</td>
            <td>{{ ctt.createdAtFormated }}</td>
            <td>{{ ctt.created_by }}</td>
            <td>{{ ctt.updatedAtFormated }}</td>
            <td>{{ ctt.updated_by }}</td>
            <td :style="{ color: ctt.activated ? '#4CDA4C' : 'red', fontWeight: 'bold' }">
              {{ showStatus(ctt.activated) }}
            </td>
            <td>
              <div class="action-holder">
                <button style="background-color: #0298cf;" @click="editClick(ctt)"
                  v-if="$checkPermission('edit_user')"><i class="fa-solid fa-pen-to-square"></i></button>
                <button style="background-color: #f80000;" @click="toggleAlert(ctt.user_id)"
                  v-if="$checkPermission('delete_user')"><i class="fa-solid fa-trash"></i></button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <div @click="changePage(currentPage - 1)" :disabled="currentPage === 1"><i class="fa-solid fa-angle-left"></i></div>
      <div @click="changePage(1)" v-if="currentPage !== 1">1</div>
      <div v-if="currentPage - 2 >= 1" style="cursor: auto;"><i class="fa-solid fa-ellipsis"></i></div>
      <div style="color: #0298cf; background: rgba(171, 171, 171, 0.2);">{{ currentPage }}</div>
      <div v-if="currentPage + 2 <= totalPages" style="cursor: auto;"><i class="fa-solid fa-ellipsis"></i></div>
      <div @click="changePage(totalPages)" v-if="currentPage !== totalPages">{{ totalPages }}</div>
      <div @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages"><i class="fa-solid fa-angle-right"></i></div>
    </div>
  </div>

  <!-- Modal -->
  <base-modal :modalActive="modalActive" :modalTitle="modalTitle" @close="toggleModal">
    <div class="data-display">
      <div class="box"> <p>Tên người dùng<span style="color: red;">*</span></p> </div>
      <input type="text" v-model="username"/>
    </div>

    <div class="data-display">
      <div class="box"> <p>Email<span style="color: red;">*</span></p> </div>
      <input type="text" v-model="email"/>
    </div>

    <div class="data-display">
      <div class="box"> <p>Trạng thái</p> </div>
      <select :style="{ color: activated ? '#4CDA4C' : 'red', fontWeight: 'bold' }" v-model="activated">
        <option style="color: #4CDA4C; font-weight: bold;" :value="true">Hoạt động</option>
        <option style="color: red; font-weight: bold;" :value="false">Bất hoạt</option>
      </select>
    </div>

    <label v-if="id !== 0">
      <input type="checkbox" v-model="changePassword"/> Đổi mật khẩu?
    </label>

    <div v-if="changePassword && id !== 0">
      <div class="data-display-pw">
        <div class="box"> <p>Mật khẩu cũ</p> </div>
        <input :type="oldPasswordFieldType" v-model="oldPassword"/>
      </div>
      <label>
        <input type="checkbox" v-model="showOldPassword" class="checkbox-ip"/> Hiện mật khẩu
      </label>
    </div>

    <div v-if="changePassword">
      <div class="data-display-pw">
        <div class="box"> <p>Mật khẩu<span style="color: red;">*</span></p> </div>
        <input :type="passwordFieldType" v-model="password"/>
      </div>
      <label>
        <input type="checkbox" v-model="showPassword" class="checkbox-ip"/> Hiện mật khẩu
      </label>
    </div>

    <div v-if="changePassword">
      <div class="data-display-pw">
        <div class="box"> <p>Xác nhận mật khẩu<span style="color: red;">*</span></p> </div>
        <input :type="confirmPasswordFieldType" v-model="confirmPassword"/>
      </div>
      <label>
        <input type="checkbox" v-model="showConfirmPassword" class="checkbox-ip"/> Hiện mật khẩu
      </label>
    </div>

    <div class="btn-container">
      <button :class="{ loading: requestLoading }" :disabled="requestLoading" v-if="id === 0" @click="createClick()">
        <p class="btn-text">Tạo</p>
      </button>
      <button :class="{ loading: requestLoading }" :disabled="requestLoading" v-if="id !== 0" @click="updateClick()">
        <p class="btn-text">Cập nhật</p>
      </button>
    </div>
  </base-modal>

  <alert-modal :modalActive="modalAlert" @close="toggleAlert(selectedId)"
    :requestLoading="requestLoading"
    @delete="deleteClick(selectedId)">
  </alert-modal>
</template>
<script>
export default {
  data () {
    return {
      pageSize: 10,
      currentPage: 1,
      isValid: true,
      modalActive: false,
      modalAlert: false,
      modalTitle: '',
      filterTerm: '',
      appliedTerm: '',
      selectedId: 0,
      isLoading: false,
      showConfirmPassword: false,
      showPassword: false,
      showOldPassword: false,
      changePassword: false,
      message: '',
      requestLoading: false,
      filterStatus: '',
      totalPages: 1,
      // data
      id: 0,
      username: '',
      password: '',
      email: '',
      oldPassword: '',
      confirmPassword: '',
      activated: false,
      propertiesToCheck: ['username', 'email', 'password', 'confirmPassword']
    }
  },
  computed: {
    getUsers () {
      return this.$store.getters['users/backendUsers']
    },
    // filterItems () {
    //   if (!this.appliedTerm) {
    //     return this.getUsers
    //   }
    //   this.reloadPageWithFilter()
    //   const searchTerm = this.appliedTerm.toLowerCase()
    //   return this.getUsers.filter(data =>
    //     data.username.toLowerCase().includes(searchTerm) ||
    //     data.email.toLowerCase().includes(searchTerm)
    //   )
    // },
    // paginatedData () {
    //   const start = (this.currentPage - 1) * this.pageSize
    //   const end = start + this.pageSize
    //   return this.filterItems.slice(start, end)
    // },
    // totalPages () {
    //   const tp = Math.ceil(this.filterItems.length / this.pageSize)
    //   if (tp === 0) return 1
    //   return tp
    // },
    oldPasswordFieldType () {
      return this.showOldPassword ? 'text' : 'password'
    },
    passwordFieldType () {
      return this.showPassword ? 'text' : 'password'
    },
    confirmPasswordFieldType () {
      return this.showConfirmPassword ? 'text' : 'password'
    }
  },
  watch: {
    filterStatus (newValue) {
      this.currentPage = 1
      this.getUserData()
    }
  },
  methods: {
    sendFilterTerm () {
      this.currentPage = 1
      this.appliedTerm = this.filterTerm
      this.getUserData()
    },
    async exportExcel () {
      this.requestLoading = true
      await this.$store.dispatch('users/exportExcel', { filteredTerm: this.appliedTerm, filteredStatus: this.filterStatus })
      this.requestLoading = false
    },
    // changePage (page) {
    //   if (page >= 1 && page <= this.totalPages) {
    //     this.currentPage = page
    //   }
    // },
    changePage (page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page
        this.getUserData()
      }
    },
    reloadPageWithFilter () {
      this.currentPage = 1
    },
    showStatus (status) {
      if (status) {
        return 'Hoạt động'
      }
      return 'Dừng'
    },
    toggleModal () {
      this.modalActive = !this.modalActive
    },
    toggleAlert (id) {
      this.selectedId = id
      this.modalAlert = !this.modalAlert
    },
    async getUserData () {
      this.isLoading = true
      this.totalPages = await this.$store.dispatch('users/getUserByPageWithFilter', { filteredTerm: this.appliedTerm, filteredStatus: this.filterStatus, pageNumber: this.currentPage })
      if (this.$store.getters['users/backendUsers'].length === 0) {
        if (this.currentPage > 1) {
          this.currentPage--
          this.totalPages = await this.$store.dispatch('users/getUserByPageWithFilter', { filteredTerm: this.appliedTerm, filteredStatus: this.filterStatus, pageNumber: this.currentPage })
        }
        if (this.totalPages < 1) this.totalPages = 1
      }
      this.isLoading = false
    },
    addClick () {
      this.modalTitle = 'Thêm người dùng'
      this.isValid = true
      this.id = 0
      this.username = ''
      this.password = ''
      this.email = ''
      this.confirmPassword = ''
      this.activated = false
      this.changePassword = true
      this.toggleModal()
    },
    validateVariable () {
      this.isValid = true
      this.propertiesToCheck.forEach(key => {
        if ((key === 'password' || key === 'confirmPassword') && this.id !== 0) {
          return
        }
        if (this[key] === '') {
          this.isValid = false
          this.message = 'Thiếu thông tin cần thiết!'
        }
        if (key === 'email' && !this[key].includes('@')) {
          this.isValid = false
          this.message = 'Email không hợp lệ!'
        }
      })
      if (this.password !== this.confirmPassword) {
        this.isValid = false
        this.message = 'Mật khẩu và mật khẩu xác nhận không giống nhau'
      }
    },
    async createClick () {
      this.requestLoading = true
      this.validateVariable()
      if (!this.isValid) {
        this.requestLoading = false
        this.$showError(this.message)
        return
      }
      const newUser = {
        username: this.username,
        password_hash: this.password,
        email: this.email,
        activated: this.activated
      }

      try {
        await this.$store.dispatch('users/postUser', newUser)
        this.requestLoading = false
        this.$showSuccess('Tạo thành công')
        this.getUserData()
        this.toggleModal()
      } catch (error) {
        this.requestLoading = false
        if (error.response.data.error_message) {
          this.$showError(error.response.data.error_message)
        } else {
          this.$showError('Đã xảy ra lỗi không mong muốn')
        }
      }
    },
    editClick (data) {
      this.toggleModal()
      this.isValid = true
      this.modalTitle = 'Chỉnh sửa người dùng'
      this.id = data.user_id
      this.username = data.username
      this.oldPassword = ''
      this.password = ''
      this.confirmPassword = ''
      this.email = data.email
      this.activated = data.activated
      this.changePassword = false
    },
    async updateClick () {
      this.requestLoading = true
      this.validateVariable()
      if (!this.isValid) {
        this.requestLoading = false
        this.$showError(this.message)
        return
      }
      if (this.password === '') {
        this.password = null
        this.confirmPassword = null
      }
      // else if (this.password && !this.oldPassword) {
      //   this.isClicked = false
      //   this.$showError('Thiếu mật khẩu cũ')
      //   return
      // }

      const updatedUser = {
        id: this.id,
        username: this.username,
        newPassword: this.password,
        oldPassword: this.oldPassword,
        email: this.email,
        activated: this.activated
      }

      try {
        await this.$store.dispatch('users/updateUser', updatedUser)
        this.requestLoading = false
        this.$showSuccess('Cập nhật thành công')
        this.getUserData()
        this.toggleModal()
      } catch (error) {
        this.requestLoading = false
        if (error.response.data.error_message) {
          this.$showError(error.response.data.error_message)
        } else {
          this.$showError('Đã xảy ra lỗi không mong muốn')
        }
      }
    },
    async deleteClick (id) {
      this.requestLoading = true
      await this.$store.dispatch('users/deleteUser', id)
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      if (this.filterItems.slice(start, end).length === 1 && this.currentPage > 1) {
        this.currentPage--
      }
      this.requestLoading = false
      this.toggleAlert()
      this.getUserData()
    }
  },
  created () {
    this.getUserData()
  }
}
</script>
<style scoped>
  .table {
    width: 100%;
  }

  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: rgb(240, 240, 240);
    flex-wrap: wrap;
  }

  .table-header p {
    color: #000;
  }

  button {
    outline: none;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    padding: 10px;
    color: #fff;
  }

  .add-new {
    padding: 10px 20px;
    color: #fff;
    background-color: #0298cf;
  }

  .excel-btn {
    position: relative;
    margin-right: 15px;
    padding: 10px 20px;
    background-color: #008000;
  }

  .excel-btn p{
    color: #fff;
  }

  .table-header select {
    padding: 10px 20px;
    margin: 0 10px;
    outline: none;
    border: 1px solid #0298cf;
    border-radius: 6px;
    color: #0298cf;
  }

  .table-header input {
    padding: 10px 20px;
    outline: none;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    border: 1px solid #0298cf;
    color: #0298cf;
  }

  ::placeholder {
    color: #0298cf;
  }

  /* table-header end */

  .table-section {
    min-height: 590px;
  }

  table {
    width: 100%;
    table-layout: auto;
    min-width: 1000px;
    border-collapse: collapse;
  }

  thead th {
    position: sticky;
    top: 0;
    background-color: #0298cf;
    color: #fff;
    font-size: 15px;
    height: 50px;
  }

  th,td {
    border-bottom: 1px solid #dddddd;
    padding: 10px 20px;
    text-align: center;
    border-right: 1px solid #dddddd;
    border-left: 1px solid #dddddd;
  }

  td {
    text-align: left;
  }

  tr:hover td {
    background-color: #cfe2ff;
  }

  .action-holder {
    display: flex;
    justify-content: space-around;
  }

  ::-webkit-scrollbar{
    height: 5px;
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3)
  }

  ::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3)
  }

  tr:nth-child(even) {background-color: #ececec }

  th:nth-child(1), td:nth-child(1) {
    text-align: center;
    width: 60px;
  }

  th:nth-child(8), td:nth-child(8), td:nth-child(9) {
    text-align: center;
    width: 120px;
  }

  td:nth-child(4), td:nth-child(5), td:nth-child(6), td:nth-child(7) {
    text-align: center;
  }

  /* table end */

  .pagination {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    padding: 20px 20px;
  }

  .pagination div{
    padding: 10px;
    border: 1px solid #d5d0d0;
    height: 40px;
    width: 40px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #0298cf;
    color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.75);
    margin: 0 5px;
    cursor: pointer;
  }

  /* modal */

  .data-display {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    /* border: 2px solid #000; */
  }

  .data-display-pw {
    display: flex;
    align-items: center;
    margin-top: 30px;
  }

  .data-display-pw input {
    height: 40px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 0px 10px;
  }
  .data-display-pw .box {
    width: 120px;
  }

  .data-display .box {
    width: 120px;
  }

  .data-display input {
    height: 40px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 0px 10px;
  }

  .btn-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 30px;
  }

  .btn-container button {
    position: relative;
    padding: 12px 30px;
    color: #fff;
    background-color: #0298cf;
  }

  .loading .btn-text {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease;
  }

  .loading::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    pointer-events: none;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 3px solid transparent;
    border-top-color: white;
    border-right-color: white;
    animation: loading 1s ease infinite;
  }

  @keyframes loading {
    0% {
      transform: rotate(0turn);
    }
    100% {
      transform: rotate(1turn);
    }
  }

  .errors {
    font-weight: bold;
    color: red;
  }

  .checkbox-ip {
    margin-left: 95px;
    border-radius: 6px;
    margin-top: 10px;
  }

  .data-display select {
    height: 40px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 0px 7px;
  }
</style>
